module.exports = __webpack_public_path__ + "static/media/iphone_preview.dcae74ed.png";